export const loginhandler = (status) => {
var actiontype;
if (status === 'login') {
 console.log('status is '+status);
  actiontype = "MakeLoginInVisible"
}
else if (status === 'logout') {
  actiontype = "MakeLoginVisible"

}
  return {
      type: actiontype,
  }
};



// WEBPACK FOOTER //
// ./src/actions/loginhandler.js